import { createNamespacedHelpers } from 'vuex';
import { prefixTypeFactory } from '../../../utils/StoreHelper';

export const NAMESPACE = 'configurator/layout';

export const { mapState, mapGetters, mapActions, mapMutations } =
  createNamespacedHelpers(NAMESPACE);

/**
 * @type {function(string): string}
 */
export const prefixType = prefixTypeFactory(NAMESPACE);

export const LayoutMutation = Object.freeze({
  SET_ACTIVE_VIEW: 'setActiveView',
  SET_ACTIVE_STEP: 'setActiveStep',
  SET_RENDER_BTN_TOOLTIP_CLICKED_STATE: 'setRenderBtnTooltipClickState',
});

/**
 * @enum
 * @readonly
 */
export const LayoutAction = Object.freeze({
  SET_RENDER_BTN_TOOLTIP_CLICKED_STATE: 'setRenderBtnTooltipClickState',
});

export const LayoutView = Object.freeze({
  SIDEBAR: 'sidebar',
  CONTENT: 'content',
});

export const SESSION_STORAGE_TOOLTIP_CLICK_STATE_KEY =
  'renderBtnTooltipClickState';

/**
 * @enum
 * @readonly
 */
export const LayoutStep = Object.freeze({
  STEP_FORMAT: 'stepFormat',
  STEP_VISUAL: 'stepVisual',
  STEP_CONTENT: 'stepContent',
});

export const LAYOUT_STEP_LIST = [
  LayoutStep.STEP_FORMAT,
  LayoutStep.STEP_VISUAL,
  LayoutStep.STEP_CONTENT,
];

class LayoutModuleError extends Error {}

export class InvalidLayoutViewError extends LayoutModuleError {}

export class InvalidLayoutStepError extends LayoutModuleError {}

export default {
  namespaced: true,
  /**
   *
   * @returns {LayoutState}
   */
  state() {
    return {
      activeView: LayoutView.CONTENT,
      hasTriggeredSidebar: false,
      hasClickedRenderBtnTooltip: false,
      activeStep: LayoutStep.STEP_FORMAT,
    };
  },
  mutations: {
    /**
     *
     * @param {LayoutState} state
     * @param payload
     */
    [LayoutMutation.SET_ACTIVE_VIEW](state, payload) {
      if (!Object.values(LayoutView).includes(payload)) {
        throw new InvalidLayoutViewError(
          `the provided layout view ${JSON.stringify(payload)} is invalid`
        );
      }

      state.activeView = payload;

      if (payload === LayoutView.SIDEBAR && !state.hasTriggeredSidebar) {
        state.hasTriggeredSidebar = true;
      }
    },
    /**
     *
     * @param {LayoutState} state
     * @param {LayoutStep} payload
     */
    [LayoutMutation.SET_ACTIVE_STEP](state, payload) {
      if (!Object.values(LayoutStep).includes(payload)) {
        throw new InvalidLayoutStepError(
          `the provided layout step ${JSON.stringify(payload)} is invalid`
        );
      }

      state.activeStep = payload;
    },
    /**
     *
     * @param {LayoutState} state
     * @param {boolean} payload
     */
    [LayoutMutation.SET_RENDER_BTN_TOOLTIP_CLICKED_STATE](state, payload) {
      state.hasClickedRenderBtnTooltip = Boolean(payload);
    },
  },
  actions: {
    /**
     *
     * @param commit
     * @param {LayoutState} state
     * @param {boolean} payload
     */
    [LayoutAction.SET_RENDER_BTN_TOOLTIP_CLICKED_STATE](
      { commit, state },
      payload
    ) {
      commit(LayoutMutation.SET_RENDER_BTN_TOOLTIP_CLICKED_STATE, payload);

      // Persist action to sessionStorage for further calls
      sessionStorage.setItem(
        SESSION_STORAGE_TOOLTIP_CLICK_STATE_KEY,
        state.hasClickedRenderBtnTooltip
      );
    },
  },
};
